import React from "react";
import { X } from "lucide-react";

/** Applied filters as removable chips. */
const ActiveFilterChips = ({ chips, onClearAll }) => {
  if (!chips.length) return null;
  return (
    <div className="flex flex-wrap items-center gap-1.5">
      {chips.map((c) => (
        <span
          key={c.key}
          className="inline-flex max-w-[280px] items-center gap-1 rounded-full border border-gray-200 bg-gray-50 py-0.5 pl-2.5 pr-1 text-xs text-gray-700"
        >
          <span className="truncate">{c.label}</span>
          <button
            type="button"
            aria-label={`Remove ${c.label}`}
            onClick={c.onRemove}
            className="rounded-full p-0.5 text-gray-400 hover:bg-gray-200 hover:text-gray-700"
          >
            <X className="h-3 w-3" />
          </button>
        </span>
      ))}
      {onClearAll && (
        <button
          type="button"
          onClick={onClearAll}
          className="px-1.5 text-xs text-gray-500 hover:text-gray-800 hover:underline underline-offset-2"
        >
          Clear all
        </button>
      )}
    </div>
  );
};

export default ActiveFilterChips;
